import { call, put, SagaIterator, takeEvery } from './sagaEffects';
import { performRequest } from './performRequestSaga';
import { FetchError, FetchFatalError, FetchRequest, FetchSuccess } from 'acscp/actions';
import { ApiResponse, ResponseType } from 'acscp/api/responses';
import history from 'acscp/store/history';
import {
    ClientInsufficientAuthErrorKey,
    ServiceTemporarilyUnavailableKey
} from 'acscp/components/common/helpers/getTranslatableErrorMessage';
import log from 'loglevel';

export function* fetchSaga(): SagaIterator {
    yield takeEvery(FetchRequest, fetchRequest);
}

export function* fetchRequest<T>(action: FetchRequest<T>): SagaIterator {
    const request = action.request;
    log.debug(`Performing request to: ${request.relativeUrl}`);
    const response = (yield call(performRequest, request)) as unknown as ApiResponse<T>;

    switch (response.type) {
        case ResponseType.Success:
            log.debug(`Request to ${request.relativeUrl} successful`);
            yield put(new FetchSuccess(request, response.payload, action.callerId));
            break;
        case ResponseType.Fatal:
            log.error(`Request to ${request.relativeUrl} failed.`, response.details);
            yield put(new FetchFatalError(request, {text: response.message}, action.callerId));
            break;
        case ResponseType.ServiceUnavailable:
            log.error(`Request to ${request.relativeUrl} failed (service unavailable).`, response.details);
            const errorMessage = {
                code: ServiceTemporarilyUnavailableKey,
                text: 'JetPortal is temporarily unavailable.'
            };
            yield put(new FetchFatalError(request, errorMessage, action.callerId));
            break;
        case ResponseType.ServerError:
            log.error(`Request to ${request.relativeUrl} resulted in ServerError.`, response.details);
            yield put(new FetchFatalError(request, response.details.message, action.callerId));
            break;
        case ResponseType.InsufficientAuth:
            yield put(new FetchError(
                request,
                ResponseType.Unauthorized,
                {
                    message: {
                        text: 'You do not have access to that resource.',
                        code: ClientInsufficientAuthErrorKey,
                    }
                },
                action.callerId));
            break;
        case ResponseType.NotFound:
            history.push('/not-found');
        default:
            log.error(`Request to ${request.relativeUrl} failed.`, response.details);
            yield put(new FetchError(request, response.type, response.details, action.callerId));
    }
}
